import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Track } from '../entities/track';
import { ProposalOrder } from '../entities/proposalOrder';
import { catchError } from 'rxjs/operators';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class TrackService {

  private baseUrl = environment.apiUrl + '/api/track/';
  basic: string | string[];

  constructor(private http: HttpClient) { }

  addTrack(track: Track): Observable<Track> {
    return this.http.post<Track>(this.baseUrl, track);
  }

  updateTrack(trackId: number, track: Track): Observable<any> {
    return this.http.put<Track>(`${this.baseUrl} ${ trackId }`, track, httpOptions)
      .pipe(
      catchError(this.handleError<any>('updateSession'))
    );
  }

  assignProposalsOrders(proposalOrderList: Array<ProposalOrder>): Observable<ProposalOrder> {
    return this.http.post<ProposalOrder>(this.baseUrl + 'proposalsorders', proposalOrderList);
  }

  unassignProposalsOrders(proposalOrderList: Array<ProposalOrder>): Observable<ProposalOrder> {
    return this.http.put<ProposalOrder>(this.baseUrl + 'proposalsorders', proposalOrderList);
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return of(result as T);
    };
  }
}
